import { stepMedicalExpensesExpenseLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  const questionnaire = [];
  const entries = Object.entries(data);
  const excludedEntries = ['prescriptionMedicinesNotInjury',
    'prescriptionMedicinesForInjury',
  ];
  entries.forEach(([property, value]) => {
    if (excludedEntries.indexOf(property) < 0) {
      questionnaire.push({
        question: `medicalExpensesExpense.${property}`,
        answer: value,
        claimTypeCode: claimCode,
      });
    }
  });
  return [...questionnaire];
}

function mapToExpenses(data) {
  const medicalExpenses = mapToMedicalExpense(data);

  return [...medicalExpenses];
}

function mapToMedicalExpense(data) {
  if (!data.expensesClaimed) {
    return [];
  }

  const claimCode = lookupClaimCode(data);
  return [{
    shortDescription: data.nameOfPhysicianFacilityFirstContacted,
    dateOfExpense: data.accidentFirstTreatment,
    clientCost: data.expensesClaimed,
    currency: data.currencyForProvide,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  }];
}

function lookupClaimCode(data) {
  const defaultClaimCode = expenseLookup.areYouClaimingForHospitalAndMedicalExpenses.claimCode;
  if (data.changeTo !== 'true') {
    return defaultClaimCode;
  }
  return !!expenseLookup.areYouClaimingForUnexpectedRecurrence.claimCode ? expenseLookup.areYouClaimingForUnexpectedRecurrence.claimCode : defaultClaimCode;
}


export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepMedicalExpensesDataMapper.js